var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.$route.meta.include}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }